// extracted by mini-css-extract-plugin
export default {"departments":"mH-z","departmentHeading":"nH-z","departmentSection":"oH-z","departmentName":"pH-z","departmentLink":"qH-z","expandIcon":"rH-z"};